import { AudienceRestrictionsOptions } from 'app/modules/posts/types/AudienceRestrictionsOptions';
import { AUDIENCE_RESTRINCTION_EMPTY_VALUE } from '../constants/audienceRestrictions';

export const mapApiDataToFormValues = (
  apiData: AudienceRestrictionsOptions,
): AudienceRestrictionsOptions => {
  const formPayload = {
    ...apiData,
  };

  if (
    !apiData.age_min ||
    (Array.isArray(apiData.age_min) && apiData.age_min.length === 0)
  ) {
    formPayload.age_min = [AUDIENCE_RESTRINCTION_EMPTY_VALUE];
  }

  return formPayload;
};
